<template>
  <div class="meet-room">
    <div class="container">
      <!-- <p
        class="success-form-msg"
        style="margin-bottom: 15px"
        v-if="showRecognizeAlert"
      >
        {{ faceRecognitionStatus }}
      </p> -->
      <div class="meet-room__column-group">
        <BModal ref="med-record" size="xl" hide-footer hide-header>
          <MedicalRecord :record-data="recordData" />
        </BModal>
        <div class="meet-room__video-column">
          <div id="local-media" class="meet-room__video-screen">
            <video
              ref="camera"
              id="preview"
              width="100%"
              height="auto"
              autoPlay
            />
            <div class="video-screen__message">
              <template v-if="videoMuted">
                A sua câmera está desligada!
              </template>
              <br />
              <template v-if="audioMuted">
                O seu microfone está desligado!
              </template>
            </div>
            <div class="video-screen__buttons-group">
              <button
                v-if="!videoMuted"
                class="video-screen__button"
                @click.prevent="muteVideo"
              >
                <b-icon-camera-video
                  style="height: 22px; width: 25px; color: #fff"
                />
              </button>
              <button
                v-else
                class="video-screen__button button-muted"
                @click.prevent="unmuteVideo"
              >
                <b-icon-camera-video-off
                  style="height: 22px; width: 25px; color: #fff"
                />
              </button>
              <button
                v-if="!audioMuted"
                class="video-screen__button"
                @click.prevent="muteAudio"
              >
                <b-icon-mic style="height: 25px; width: 22px; color: #fff" />
              </button>
              <button
                v-else
                class="video-screen__button button-muted"
                @click.prevent="unmuteAudio"
              >
                <b-icon-mic-mute
                  style="height: 25px; width: 22px; color: #fff"
                />
              </button>
            </div>
          </div>
        </div>

        <!-- sala virtual info card -->
        <div class="meet-room__card-column">
          <div class="meet-room__card">
            <div v-if="userRole == 'doctor'" class="meet-room__card-top">
              <div class="meet-room__avatar">
                <div class="meet-room__image-wrapper">
                  <div
                    class="meet-room__image"
                    :style="`background-image: url(${photoFallback()})`"
                  />
                </div>
                <h6 class="meet-room__name">{{ room.patient.name }}</h6>
              </div>
              <button class="button4" @click="showModal">Ficha médica</button>
              <button class="button4" @click="showPlataformaPrescricao">
                Prescrição médica
              </button>
            </div>

            <h2 class="meet-room__title">A sala está pronta</h2>
            <div class="meet-room__clipboard-group">
              <h6 class="meet-room__subtitle">URL da sua consulta:</h6>
              <form>
                <div class="meet-room__form-wrapper">
                  <input type="text" :value="roomLink" readonly />
                  <button type="button" @click="copyToClipboard" title="copiar">
                    <img src="../assets/images/link-icon.svg" />
                  </button>
                </div>
                <span v-if="linkUrlCopied" class="meet-room__clipboard-msg">
                  <img src="../assets/images/check-icon.svg" />
                  Copiado!
                </span>
              </form>
            </div>

            <!-- <div class="meet-room__reminder-group">
              <h6 class="meet-room__subtitle">Enviar lembrete por:</h6>
              <form class="meet-room__form-inline">
                <a type="button" href="#">
                  <img src="../assets/images/envelope-icon.svg" />
                </a>
                <a type="button" href="#">
                  <img src="../assets/images/telephone-icon.svg" />
                </a>
              </form>
            </div> -->

            <div class="meet-room__card-bottom">
              <button
                :disabled="!canJoinRoom"
                class="button3"
                :class="{ disable: !canJoinRoom }"
                @click="joinMeetingRoom(room)"
              >
                Abrir sala virtual
              </button>
              <button class="button3">Cancelar consulta</button>
            </div>
          </div>
        </div>

        <Loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  roomMethods,
  userComputed,
  userMethods,
  faceRecognitionMethods
} from "./../state/helpers";
import { connect, createLocalVideoTrack } from "twilio-video";
import MedicalRecord from "../components/MedicalRecord";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Compressor from "compressorjs";

export default {
  components: {
    MedicalRecord,
    Loading
  },
  data() {
    return {
      murilo: false,
      takePhotoInterval: null,
      faceRecognitionAlert: true,
      doctorValidated: true,
      sendingPhoto: false,
      photo: "",
      audioMuted: false,
      videoMuted: false,
      room: {
        patient: {
          name: "",
          photo: ""
        }
      },
      roomInstance: {},
      localTracks: {},
      linkUrlCopied: false,
      recordData: {
        symptoms: [],
        patient: {},
        observation: undefined,
        last_appointment: null
      },
      loading: false,
      gotDevices: false,
      cameraRef: null,
      camera: {
        blob: null,
        devices: [],
        constraints: { audio: true, video: { width: 555, height: 367 } },
        selected: null,
        disableButton: false,
        capturedImages: []
      },
      memedPatient: null
    };
  },
  mounted() {
    this.getRoomDetails(this.$route.params.room).then(response => {
      this.room = response.data;
      this.showSymptoms({ id: response.data.patient.id })
        .then(response => {
          this.memedPatient = response.data.user;
        })
        .catch(error => console.log(error));
    });
    this.cameraRef = this.$refs.camera;
    this.startCam();
    // if (this.userRole == "doctor")
    //   this.takePhotoInterval = setInterval(() => {
    //     this.takePhoto();
    //   }, 3000);
  },
  updated() {
    if (this.linkUrlCopied) {
      setTimeout(() => {
        this.linkUrlCopied = false;
      }, 10000);
    }
  },
  destroyed() {
    this.stopCam()
  },
  methods: {
    ...roomMethods,
    ...userMethods,
    ...faceRecognitionMethods,
    startCam() {
      var constraints = { video: { width: 555, height: 367 } };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (mediaStream) {
          var video = document.querySelector("video");
          video.srcObject = mediaStream;
          video.onloadedmetadata = function (e) {
            video.play();
          };
        });
    },
    stopCam() {
      if (this.cameraRef && this.cameraRef.srcObject) {
        this.cameraRef.srcObject.getVideoTracks().map(stream => stream.stop());
      }
    },
    muteAudio() {
      if (this.cameraRef && this.cameraRef.srcObject) {
        this.cameraRef.srcObject.getAudioTracks().map(stream => stream.stop());
      }
      this.audioMuted = true;
    },
    unmuteAudio() {
      this.audioMuted = false;
    },
    muteVideo() {
      this.videoMuted = true;
      // clearInterval(this.takePhotoInterval);
      this.stopCam();
    },
    unmuteVideo() {
      this.videoMuted = false;
      this.startCam();
      // if (this.userRole == "doctor")
      //   this.takePhotoInterval = setInterval(() => {
      //     this.takePhoto();
      //   }, 3000);
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.roomLink);
      this.linkUrlCopied = true;
    },
    showModal(data) {
      this.showSymptoms({ id: this.room.patient.id }).then(response => {
        this.recordData.symptoms = response.data.symptoms;
        this.recordData.patient = response.data.user;
        this.recordData.observation = response.data.observation;
        this.recordData.last_appointment = response.data.last_appointment;
        this.loading = false;
        this.$refs["med-record"].show();
      });
    },
    photoFallback() {
      return (
        this.room.patient.photo || require("../assets/images/doctor-img.jpg")
      );
    },
    joinMeetingRoom(room) {
      this.$router.push({
        name: "MeetingRoom",
        params: {
          room: room.id,
          audioMuted: this.audioMuted,
          videoMuted: this.videoMuted
        }
      });
    },
    takePhoto() {
      let that = this;

      navigator.mediaDevices.getUserMedia({ video: true }).then(mediaStream => {
        const track = mediaStream.getVideoTracks()[0];
        let imageCapture = new ImageCapture(track);
        imageCapture.takePhoto().then(blob => {
          const compressor = new Compressor(blob, {
            quality: 0.2,
            height: 540,
            width: 960,
            success(result) {
              var reader = new FileReader();
              reader.readAsDataURL(result);
              reader.onloadend = function () {
                that.photo = reader.result;
              };
            }
          });
        });
      });
    },
    showPlataformaPrescricao() {
      window.MdHub.command
        .send("plataforma.prescricao", "setPaciente", {
          nome: this.memedPatient.name,
          telefone: this.memedPatient.phone_number,
          dificuldade_locomocao: true,
          idExterno: this.memedPatient.id
        })
        .then(() => {
          window.MdHub.command.send(
            "plataforma.prescricao",
            "setFeatureToggle",
            {
              deletePatient: false,
              removePatient: false,
              editPatient: false
            }
          );
          window.MdHub.module.show("plataforma.prescricao");
        });
    }
  },
  computed: {
    ...userComputed,
    roomLink() {
      return `${window.location.href}`;
    },
    faceRecognitionStatus() {
      if (!this.doctorValidated && this.sendingPhoto)
        return "Validando informação";
      if (!this.doctorValidated)
        return "Favor olhar para webcam por alguns segundos enquanto fazemos uma validação de segurança.";

      return "Dados validados, boa consulta!";
    },
    showRecognizeAlert() {
      return (
        this.faceRecognitionAlert &&
        this.userRole == "doctor" &&
        !this.videoMuted
      );
    },
    canJoinRoom() {
      if (this.isDoctor) return this.doctorValidated;

      return true;
    }
  },
  watch: {
    photo(newValue) {
      if (newValue && !this.sendingPhoto) {
        // this.$set(this, "sendingPhoto", true);
        // this.imageRecognize({ image: newValue })
        //   .then(response => {
        //     this.sendingPhoto = false;
        //     this.doctorValidated = response.data.verified;
        //     if (!response.data.verified) this.photo = "";
        //   })
        //   .catch(error => {
        //     this.sendingPhoto = false;
        //     this.photo = "";
        //   });
      }
    },
    doctorValidated(newValue) {
      if (newValue) {
        // this.faceRecognitionAlert = false;
        // clearInterval(this.takePhotoInterval);
      }
    }
  }
};
</script>

<style lang="css" scoped>
.meet-room {
  margin: 180px 0;
}
.meet-room__column-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
@media (max-width: 992px) {
  .meet-room__column-group {
    grid-template-columns: 1fr;
  }
}

.meet-room__video-screen {
  position: relative;
  height: 100%;
  min-height: 365px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  border-radius: 16px;
  overflow: hidden;
}
@media (max-width: 992px) {
  .meet-room__video-screen {
    min-height: 365x;
    width: 100%;
  }
}
.video-screen__message {
  text-align: center;
  position: absolute;
  font-size: 18px;
  width: 100%;
  color: #fff;
}
.video-screen__buttons-group {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 0 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 68.85%, #000000 125.14%);
  z-index: 2000;
}
.video-screen__button {
  height: 50px;
  width: 50px;
  background: none;
  border-radius: 50%;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.video-screen__button:first-child {
  margin: 0 8px 0 0;
}
.video-screen__button:hover {
  background: rgba(255, 255, 255, 0.6);
}
.button-muted {
  background: red;
  border-color: red;
}
.button-muted:hover {
  background: #e50000;
  border-color: #e50000;
}

.meet-room__card-column:nth-child(2) {
  display: flex;
  align-items: center;
  justify-content: center;
}

.meet-room__card-column {
  padding: 0 40px;
}
@media (max-width: 992px) {
  .meet-room__card-column {
    padding: 40px;
  }
}
.meet-room__card-top {
  margin: 0 0 35px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.meet-room__avatar {
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .meet-room__card-top,
  .meet-room__avatar {
    flex-direction: column;
  }
}
.meet-room__image-wrapper {
  border: 3px solid #f8002d;
  border-radius: 50%;
}
.meet-room__image {
  height: 58px;
  width: 58px;
  border: 3px solid #fff;
  border-radius: 50%;
  background-color: #eaeaea;
  background: url("../assets/images/doctor-img.jpg");
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.meet-room__name {
  margin: 0 0 0 16px;
  max-width: 180px;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  color: #333333;
}
@media (max-width: 768px) {
  .meet-room__name {
    margin: 16px 0 16px 0;
    max-width: 100%;
  }
}
.meet-room__medical-record {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  margin: 0px;
  background: #fff;
  padding: 8px 12px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  transition: all 0.3s ease;
}
.meet-room__medical-record:hover,
.meet-room__medical-record:focus {
  background: #fff;
  color: #333;
  border-color: #333;
  outline: none;
}
.meet-room__title {
  margin: 0px;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.5px;
  color: #333333;
}
.meet-room__subtitle {
  margin: 0 0 8px 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #999999;
}
@media (max-width: 768px) {
  .meet-room__title,
  .meet-room__subtitle {
    text-align: center;
  }
}
.meet-room__clipboard-group {
  margin: 16px 0 16px 0;
}
.meet-room__clipboard-group > form,
.meet-room__form-wrapper {
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .meet-room__clipboard-group > form {
    flex-direction: column;
  }
}
.meet-room__form-wrapper > input {
  margin: 0 8px 0 0;
  min-width: 263px;
  padding: 12px 8px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
  color: #333333;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  transition: all 0.3s ease;
}
.meet-room__form-wrapper > input:hover,
.meet-room__form-wrapper > input:focus {
  border-color: #333;
  outline: none;
}
.meet-room__form-wrapper > button,
.meet-room__form-inline > a {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 12px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  background-color: #fff;
  transition: all 0.3s ease;
}
.meet-room__form-wrapper > button:hover,
.meet-room__form-wrapper > button:focus,
.meet-room__form-inline > a:hover,
.meet-room__form-inline > a:focus {
  border-color: #333;
  outline: none;
  background-color: #fff;
}
.meet-room__form-inline > a:not(:last-child) {
  margin: 0 8px 0 0;
}
.meet-room__clipboard-msg {
  margin: 0 0 0 24px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  color: #f8002d;
}
@media (max-width: 768px) {
  .meet-room__clipboard-msg {
    margin: 24px 0 0 0;
  }
}
.meet-room__clipboard-msg > img {
  margin: 0 8px 0 0;
}
.meet-room__reminder-group {
  margin: 16px 0 16px 0;
}
.meet-room__reminder-group > form {
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .meet-room__reminder-group > form {
    justify-content: center;
  }
}
.meet-room__card-bottom {
  display: flex;
  align-content: center;
}
.meet-room__card-bottom > button {
  padding: 16px 48px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}
.meet-room__card-bottom > button:first-child {
  margin: 0 8px 0 0;
}
@media (max-width: 575px) {
  .meet-room__card-bottom {
    flex-direction: column;
  }
  .meet-room__card-bottom > button:first-child {
    margin: 0 0 8px 0;
  }
}
.memed-container-show {
  position: fixed;
  margin: 0 auto;
  top: 82px;
  /* Largura mínima 820px */
  width: 100%;
  height: 710px;
  z-index: 3000;
  display: flex;
  flex-direction: column;
}
.memed-container {
  position: fixed;
  margin: 0 auto;
  /* Largura mínima 820px */
  width: 0;
  height: 0;
  top: -80px;
}
.memed-close {
  margin-left: auto;
  margin-right: 1.2em;
  background-color: #ff4d4d;
  border: none;
  min-width: 120px;
}
</style>
